import { StandardButton } from '@/components/buttons';
import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { WorkflowFooter } from '@/components/workflow/workflow-footer';
import { useNavigate } from '@tanstack/react-router';
import { useBaleCreateContext } from '../hook';

export const BaleCreateScanPage = () => {
	const { handleScan, setPage } = useBaleCreateContext();
	const navigate = useNavigate();

	return (
		<MobileContainer
			footer={
				<WorkflowFooter>
					<StandardButton onClick={() => setPage('MANUAL')} variant="filled" fullWidth>
						Enter Code Manually
					</StandardButton>
				</WorkflowFooter>
			}
			header={
				<MobileHeader
					title="Creation Bale Scan"
					onClose={() => navigate({ to: '/facility/home' })}
				/>
			}
		>
			<Scanner onScan={handleScan} />
		</MobileContainer>
	);
};
